import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import type { IStickyToComponent, StickyToComponentHandlers } from '../types'
import { name, StickyToComponentSymbol } from '../symbols'

export const HeaderObserverEditModeSwitchHandler = withDependencies(
	[StickyToComponentSymbol, named(EditorFeatureConfigSymbol, name)],
	(
		{ initHeaderObserver, destroyHeaderObserver }: IStickyToComponent,
		editorConfig
	): IModelUpdatesHandlersImplementor<StickyToComponentHandlers> => {
		let prevEditMode: string

		return {
			featureName: name,
			handlers: {
				onEditModeChanged: ({ editMode: newEditMode }) => {
					if (prevEditMode && prevEditMode !== newEditMode && editorConfig.shouldObserveHeader) {
						if (newEditMode === 'preview') {
							initHeaderObserver()
						} else if (newEditMode === 'editor') {
							destroyHeaderObserver()
						}
					}

					prevEditMode = newEditMode
				},
			},
		}
	}
)
